import React from 'react';
import { Award, ExternalLink } from 'lucide-react';

// Only credentials we can link to a source are shown. Specific marketing
// services (drone, 3D tours, etc.) are not published on her brokerage site
// and are intentionally omitted rather than fabricated.
const credentials = [{
  label: 'Buyer\u2019s Agent',
  source: 'Zillow',
  url: 'https://www.zillow.com/profile/RothGetsResults'
}, {
  label: 'Listing Agent',
  source: 'Zillow',
  url: 'https://www.zillow.com/profile/RothGetsResults'
}, {
  label: 'Staging',
  source: 'Zillow',
  url: 'https://www.zillow.com/profile/RothGetsResults'
}, {
  label: 'Property Management',
  source: 'Zillow',
  url: 'https://www.zillow.com/profile/RothGetsResults'
}, {
  label: 'Luxury Certified',
  source: 'FastExpert',
  url: 'https://www.fastexpert.com/agents/krystle-roth-2375/'
}, {
  label: 'Top 20% of agents nationwide',
  source: 'FastExpert',
  url: 'https://www.fastexpert.com/agents/krystle-roth-2375/'
}, {
  label: 'Certified Real Estate Planner',
  source: 'Roth Real Estate Group',
  url: 'https://rothgetsresults.kw.com/'
}, {
  label: 'CA DRE Broker License #01492471',
  source: 'CA DRE',
  url: 'https://www2.dre.ca.gov/PublicASP/pplinfo.asp?License_id=01492471'
}];
export function AgentCapabilities() {
  return <section className="py-12 px-6 md:px-12 max-w-6xl mx-auto pt-[12px] pb-[12px] pl-[48px] pr-[48px]" data-id="element-108">
      <div className="mb-6" data-id="element-109">
        <h2 className="text-2xl font-serif text-brand-dark mb-2" data-id="element-110">
          Credentials
        </h2>
        <p className="text-sm text-brand-muted" data-id="element-111">
          Each credential links to its public source
        </p>
      </div>

      <div className="flex flex-wrap gap-2" data-id="element-112">
        {credentials.map(c => <a key={c.label} href={c.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2.5 bg-brand-sandstoneBg border border-brand-sandstone/40 rounded-full text-sm text-brand-driftwood hover:border-brand-clay/60 transition-colors group" data-id="element-113">

            <Award size={15} className="text-brand-clay" data-id="element-114" />
            <span className="font-medium" data-id="element-115">{c.label}</span>
            <span className="text-[10px] text-brand-muted font-mono" data-id="element-116">
              {c.source}
            </span>
            <ExternalLink size={12} className="text-brand-muted opacity-60 group-hover:opacity-100 transition-opacity" data-id="element-117" />
          </a>)}
      </div>
    </section>;
}